<template>
  <div class="gp-content">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DashboardSection',
  computed: {
    tabs() {
      return [
        {
          label: 'Dashboard',
          link: {
            name: 'dashboard.index',
          },
          icon: 'dashboard',
        },
      ];
    },
  },
  mounted() {
    this.SET_SECTION('DashBoard');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
